// extracted by mini-css-extract-plugin
export default {"overlay":"NavigationLoadingOverlay_overlay__gGk3K"};